/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import { IPackaging } from '../interfaces/my-puratos/IGeneric';

export type Store = {
    productPage: {
        product?: Array<IPackaging>;
        productLoading: boolean;
        productLoaded: boolean;
        activeSku?: number;
        error?: string;
    };
};

export const getSkus = (state: Store): undefined | Array<IPackaging> =>
    state?.productPage?.product ?? [];

export const getActiveSku = (state: Store): IPackaging | undefined => {
    return (
        getSkus(state).filter(
            (sku) => sku.materialNumber == getActiveSkuNumber(state)
        )[0] ?? undefined
    );
};

export const getActiveSkuFromVariations = (state: Store, variations) =>
    variations.filter(
        (variation) => variation.materialNumber == getActiveSkuNumber(state)
    )[0] ?? undefined;

export const getActiveSkuNumber = (state: Store): number =>
    state.productPage?.activeSku ?? 0;

export const getSkuSizes = (state: Store): Array<string> =>
    state?.productPage?.product?.map(
        (sku) => sku.packaging + ' ' + sku.baseUnit
    ) ?? [];

export const isProductPageLoaded = (state: Store): boolean =>
    state.productPage?.productLoaded ?? false;

export const getProductPageError = (state: Store): string | undefined =>
    state.productPage?.error ?? undefined;

export const getSkuWithNumber = (skus, number) =>
    skus.filter((sku) => sku.materialNumber == number)[0] ?? undefined;

export const getVariationWithNumber = (variations, number) =>
    variations.filter((variation) => variation.materialNumber == number)[0] ??
    undefined;
